<template>
  <div class="header-list flex dir-rtl">
    <slot>{{ text }}</slot>
    <div class="icon">
      <BaseIconX nameIcon="x-list" class="no-bg" @click="toggleList" />
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"],
  methods: {
    toggleList() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="scss" scoped>
.header-list {
  height: 22px;
  font-size: 12px;
  font-weight: bold;
  line-height: 22px;
  color: #b2b2b2;
  padding: 0 8px 0 0;
  position: relative;
  //min-width: 230px;
  .icon {
    margin-right: auto;
  }
}
</style>
